import { Grid, List, ListItem, ListItemText, Popover } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import * as React from 'react';
import { compose, pure } from 'recompose';
import Button, { styles } from './Button';
const PopoverButton = ({ classes, classNames, disabled, icon, isLoading, options, title, testId = 'PopoverButton', }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = React.useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    const handleClose = React.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);
    const handleAction = React.useCallback((cb) => () => {
        cb();
        handleClose();
    }, [handleClose]);
    const open = Boolean(anchorEl) && !disabled && !isLoading;
    const id = open ? `hover-button-popover-${title}` : undefined;
    return (React.createElement(Grid, { alignItems: "center", className: classNames && classNames.container, container: true, direction: "column", "data-testid": `${testId}` },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Button, { "aria-describedby": id, disabled: disabled, iconName: icon, isLoading: isLoading, label: title, onClick: handleClick, "data-testid": `${testId}-button` }),
            React.createElement(Popover, { anchorEl: anchorEl, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, className: classes.popoverButton, id: id, onClose: handleClose, open: open, transformOrigin: { vertical: 'top', horizontal: 'center' }, "data-testid": `${testId}-popover` },
                React.createElement(List, { component: "nav" }, options.map((option, index) => {
                    return (React.createElement(ListItem, { button: true, key: index, "data-testid": `${testId}-item-${index}` },
                        React.createElement(ListItemText, { primary: option.title, onClick: handleAction(option.onClick), "data-testid": `${testId}-itemText` })));
                }))))));
};
const ComposedPopoverButton = compose(pure, withStyles(styles, { withTheme: true }))(PopoverButton);
ComposedPopoverButton.displayName = 'PopoverButton';
export default ComposedPopoverButton;
//# sourceMappingURL=PopoverButton.js.map